import { observable } from "@chorda/core";
import { Cell, Row, Table } from "chorda-bulma";
import { NhlApi } from "../../api";
import { Text } from '../../helpers';
const TEAMS = observable([]);
NhlApi.api.getTeams().then(response => {
    TEAMS.$value = response.teams;
});
export default () => {
    return {
        templates: {
            content: Table({
                headerRows: [
                    Row({
                        cells: [
                            { text: 'Name' },
                            { text: 'Abbr' },
                            { text: 'FirstYearOfPlay' },
                            { text: 'Division' },
                            { text: 'Venue' },
                            { text: 'Conference' },
                            { text: 'Franchise' },
                        ]
                    })
                ],
                defaultRow: Row({
                    cells: [
                        Text({
                            as: Cell,
                            text$: $ => $.data.name
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.abbreviation
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.firstYearOfPlay
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.division.nameShort
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.venue.name
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.conference.name
                        }),
                        Text({
                            as: Cell,
                            text$: $ => $.data.franchise.teamName
                        }),
                    ]
                }),
                data$: () => TEAMS
            })
        }
    };
};
